/**
 * Due hard rush to do this element, code quality does not follow best practices.
 * This code will and must be refactored when time is right. But for now it is what it is.
 * Please, do not blame me, blame the rush :(
 *
 * Respectfully yours.
 */
import noUiSlider from 'nouislider';
import EmissionOffset from './emission-offset';
import analytics from '../analytics';
import once from 'lodash/once';

const MAX_DONUT_VALUE = 13;
const DEFAULT_SLIDER_VALUE = 15;

class EmissionComparison
{
  constructor() {
    if(document.querySelector('.car-selection-dropdown')) {
      document.getElementById('example-vehicle').addEventListener('click', this._toggleCarSelectionDropdown.bind(this));
      // Get add to comparison buttons and add eventlistener to it
      const addToComparisonButtons = document.querySelectorAll('.add-to-comparison-container a');
      for(const comparisonButton of addToComparisonButtons) {
        comparisonButton.addEventListener('click', this._addCarToComparison.bind(this));
      }
    }

    // If universal donut conainer, set bigger radius
    this.universalDonutContainer = document.getElementsByClassName('emission-comparison-universal');

    // Init form submitting and slider events
    this._initSlider();

    this._donutDetails = [];
    this._currentDonutRadius = this.universalDonutContainer.length > 0 ? 215 : 170;
    const donuts = document.getElementsByClassName('doughnut');

    for(let i = 0; i < donuts.length; i++) {
      this._currentDonutRadius = this._currentDonutRadius - 25;
      const createdDonut = this.createDonut(donuts[i], this._currentDonutRadius);
      this._donutDetails.push(createdDonut);
    }

    // List item hover listeners
    if(this.universalDonutContainer.length === 0) {
      const listItems = document.querySelectorAll('.comparison-settings > li');
      for(const listItem of listItems) {
        listItem.addEventListener('mouseenter', (event) => {
          if(!event.target.classList.contains('no-hover')) {
            this._doughnutHoverEvents(event.target.id, false);
          }
        });
        listItem.addEventListener('mouseleave', (event) => {
          if(!event.target.classList.contains('no-hover')) {
            this._doughnutHoverEvents(event.target.id, true);
          }
        });
      }
    }

    const collapseContainerArea = document.querySelector('.emission-collapse');

    if( collapseContainerArea ) {
      this._openCollapseArea = once(() => {
        collapseContainerArea.classList.add('emission-collapse--open');
      });
    }

    // Initialize sidepanel values
    this._initSidepanelValues(true);

    // Calculate selectable cars emissions
    this._calculateSelectableCarsEmissions(DEFAULT_SLIDER_VALUE);
  }

  /**
   * Initialize sidepanel values when loading page
   *
   * @param {boolean} useDefaultSliderValue - Use default value instead slider value
   *
   * @returns {undefined}
   */
  _initSidepanelValues(useDefaultSliderValue = false) {
    const currentSliderValue = this._getSliderCurrentValue(useDefaultSliderValue);
    for(const donut of this._donutDetails) {
      const emissionsPerYear = EmissionOffset.calculateEmissionsPerYear(donut.carEmissions, currentSliderValue * 1000);
      document.getElementById(donut.baseElement.dataset.sidepanelTargetId)
        .querySelector('.co2-emissions')
        .innerText = emissionsPerYear.toFixed(2).replace('.', ',');
    }
  }

  /**
   * Calls private methods _createSVG and adds it to dom
   *
   * @param {object} element - Element to create
   * @param {number} radius  - Element radius
   * @param {boolean} useDefaultSliderValue - If initializing, slider might not return real value, use DEFAULT if set true
   *                                          Otherwise get it from slider element. Used when adding new donut
   *
   * @returns {object}
   */
  createDonut(element, radius, useDefaultSliderValue) {
    // Add radius to dataset, we will use it l8r
    element.dataset.radius = radius;

    const elements = this._createSVG(element, useDefaultSliderValue);
    element.appendChild(elements.doughnutLabel);
    element.appendChild(elements.svgElement);

    return {
      carEmissions: element.dataset.carEmissions,
      baseElement: element,
      radius,
      elements
    }
  }

  /**
   * Creates elements, but does not append it to dom
   *
   * @param {object} element - Element object
   * @param {boolean} useDefaultSliderValue - If initializing, slider might not return real value, use DEFAULT if set true
   *                                          Otherwise get it from slider element. Used when adding new donut
   *
   * @returns {object}
   */
  _createSVG(element, useDefaultSliderValue = true) {
    const svgElement        = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
      circleElement     = document.createElementNS('http://www.w3.org/2000/svg', 'circle'),
      svgWidthAndHeight = 2.3 * element.dataset.radius, // svg w & y
      svgCyCx           = svgWidthAndHeight / 2; // cy, cx

    svgElement.setAttributeNS(null, 'width', svgWidthAndHeight);
    svgElement.setAttributeNS(null, 'height', svgWidthAndHeight);

    circleElement.setAttributeNS(null, 'r', element.dataset.radius);
    circleElement.setAttributeNS(null, 'cy', svgCyCx);
    circleElement.setAttributeNS(null, 'cx', svgCyCx);
    circleElement.setAttributeNS(null, 'stroke-width', '15');
    circleElement.setAttributeNS(null, 'stroke', element.dataset.stroke);
    circleElement.setAttributeNS(null, 'fill', 'none');
    circleElement.setAttributeNS(null, 'stroke-linecap', 'round');
    circleElement.classList.add(`doughnut-${element.dataset.radius}`);

    // Get current slider value
    const currentSliderValue = this._getSliderCurrentValue(useDefaultSliderValue);

    // Pre calculate given values to donut
    const emissions = EmissionOffset.calculateEmissionsPerYear(element.dataset.carEmissions, currentSliderValue * 1000);
    const strokes = this._calculateDonutDashoffset((emissions / MAX_DONUT_VALUE) * 100, element.dataset.radius);
    circleElement.style.strokeDasharray = strokes.strokeDasharray;
    circleElement.style.strokeDashoffset = strokes.strokeDashoffset;

    // Create label
    const doughnutLabel = document.createElement('label');
    const emissionsTotal = document.createElement('span');
    emissionsTotal.classList.add(`label-value-${element.dataset.radius}`);
    emissionsTotal.innerText = ' ' + emissions.toFixed(2).replace('.',',') + ' t';
    doughnutLabel.innerText = `${element.dataset.label}`;
    doughnutLabel.appendChild(emissionsTotal);
    doughnutLabel.classList.add('theta');

    svgElement.appendChild(circleElement);
    return {
      svgElement,
      doughnutLabel,
      circleElement
    }
  }

  /**
   * Return current slider value
   *
   * @param {boolean} useDefaultSliderValue - Use DEFAULT_SLIDER_VALUE instead of slider value
   *
   * @returns {number}
   */
  _getSliderCurrentValue(useDefaultSliderValue = false) {
    const sliderElement = document.getElementById('mileage-slider').noUiSlider;
    return useDefaultSliderValue ? DEFAULT_SLIDER_VALUE : parseFloat(sliderElement.get().replace(/\D/g, ''));
  }

  /**
   * Create mouseover events for labels and doughnuts
   * Had to do this via javascript. CSS Selectors couldn't do this.
   *
   * @param {string}  hoveredElementId - Identify as classname which doughnut hovered
   * @param {boolean} isMouseOut       - Mouse out or in
   */
  _doughnutHoverEvents(hoveredElementId, isMouseOut = false) {
    // Get circle elements and labels
    const circles = document.querySelectorAll('.emission-comparison .doughnut svg circle');
    // Add circle hovers if isMouseOut is false
    if(!isMouseOut) {
      // Get big value value
      const bigValue = document.querySelector('.emission-comparison .big-value');
      bigValue.innerText = document.getElementById(hoveredElementId).querySelector('.co2-emissions').innerText + ' t';
      bigValue.style.display = 'block';
      for(const circle of circles) {
        const label = circle.parentNode.parentNode.querySelector('label');
        if(circle.parentNode.parentNode.dataset.sidepanelTargetId === hoveredElementId) {
          circle.classList.add('circle-hovered');
          label.classList.add('circle-hovered');
        } else {
          circle.classList.add('other-circle-hovered');
          label.classList.add('other-circle-hovered');
        }
      }
    } else {
      document.querySelector('.emission-comparison .big-value').style.display = 'none';
      for(const circle of circles) {
        circle.classList.remove('other-circle-hovered', 'circle-hovered');
        circle.parentNode.parentNode.querySelector('label')
          .classList.remove('circle-hovered', 'other-circle-hovered');
      }
    }
  }

  /**
   * Calculate doughnut dashoffset
   *
   * @param {number} percent - Percent to fill circle
   * @param {number} radius  - Circle radius
   *
   * @returns {object} - Dashoffset and dasharray values
   */
  _calculateDonutDashoffset(percent, radius) {
    const strokeDasharrayMultiplier = 6.555555555555,
      strokeDashoffsetMultipier = 1.833333333333,
      strokeDashoffsetMax       = radius * strokeDashoffsetMultipier,
      strokeDasharrayMax        = radius * strokeDasharrayMultiplier,
      fillPercent               = (100 - percent) / 100,
      donutArea                 = strokeDasharrayMax - strokeDashoffsetMax;
    return {
      strokeDashoffset: donutArea * fillPercent + strokeDashoffsetMax,
      strokeDasharray: strokeDasharrayMax
    }
  }

  /**
   * Change element style strokeDashoffset value
   *
   * @param {object} element  - Element to change
   * @param {number} newValue - New value of dashoffset
   */
  _changeDonutValue(element, newValue) {
    element.style.strokeDashoffset = newValue;
  }

  /**
   * Initialize mileage slider via noUiSlider
   *
   * @returns {undefined}
   * @private
   */
  _initSlider() {
    noUiSlider.create(document.getElementById('mileage-slider'), {
      range: {
        min: 0,
        max: 54
      },
      step: 5,
      start: DEFAULT_SLIDER_VALUE,
      direction: 'ltr',
      orientation: 'horizontal',
      connect: [true, false],
      behaviour: 'tap-drag',
      tooltips: true,
      format: {
        from: (value) => value,
        to: (value) => `${Math.ceil(value)} tkm`
      }
    });

    this._initSliderEvents();
  }

  /**
   * Initializes slider set events
   * Insert slider value to hidden input when slide handle released
   *
   * @returns {undefined}
   * @private
   */
  _initSliderEvents() {
    const slider       = document.getElementById('mileage-slider'),
      mileageInput = document.getElementById('mileage-per-year');

    slider.noUiSlider.on('slide', (values) => {
      this?._openCollapseArea();
      const value = values[0].replace(/\D/g, '');
      if(parseInt(value) < 5) {
        slider.noUiSlider.set(5);
      } else if(parseInt(value) > 50) {
        slider.noUiSlider.set(50);
      } else {
        mileageInput.value = value;
        // Loop through this._donutDetails and change value
        for(const donut of this._donutDetails) {
          // Calculate emissions
          const emissionsPerYear = EmissionOffset.calculateEmissionsPerYear(donut.carEmissions, value * 1000),
            donutDashoffset  = this._calculateDonutDashoffset((emissionsPerYear / MAX_DONUT_VALUE) * 100, donut.radius);
          this._changeDonutValue(donut.elements.circleElement, donutDashoffset.strokeDashoffset);
          document.querySelector(`.label-value-${donut.radius}`).innerText = ' ' + emissionsPerYear.toFixed(2).replace('.',',') + ' t';

          // Change ton value to sidepanel
          document.getElementById(donut.baseElement.dataset.sidepanelTargetId).querySelector('.co2-emissions')
            .innerText = emissionsPerYear.toFixed(2).replace('.',',');
        }

        // If universal, calculate selectable cars emissions
        this._calculateSelectableCarsEmissions(value);
      }
    });

    slider.noUiSlider.on('end', () => {
      // Insert analytics
      analytics.pushUIInteractionAnalytics({
        element: 'input',
        type: 'slide-end',
        elementName: 'UI - Päästölaskuri - Kilometrit'
      });
    })
  }

  /**
   * Get car emissions from ajax-endpoint
   *
   * @param {string} license - License to get
   * @param {string} cmToken - Stage token
   *
   * @returns {object}
   */
  async _getCarEmissionDetails(license, cmToken) {
    const response =  await fetch(`/stage-ajax/get-emissions-by-license/?license=${license}&stageToken=${cmToken}`);
    return await response.json();
  }

  /**
   * Event listener hides my car details from sidepanel and
   * deletes donut from donut area
   *
   * @returns {undefined}
   */
  _modifyCarEventListener() {
    const listItem              = document.getElementById('own-vehicle'),
      myCarDetailsContainer = listItem.querySelector('.own-vehicle-details'),
      addVehicleContainer   = listItem.querySelector('.add-own-vehicle'),
      donutContainer        = document.querySelector('[data-sidepanel-target-id="own-vehicle"]');

    // Delete donutContainer
    donutContainer.parentNode.removeChild(donutContainer);

    // Hide myCarDetailsContainer
    myCarDetailsContainer.style.display = 'none';
    addVehicleContainer.style.display = 'block';
    listItem.classList.add('no-hover');
    // Hide big value because mouse is still over the own car list item
    this._doughnutHoverEvents(null, true);

    addVehicleContainer.querySelector('input[type="submit"]').disabled = false;

    // Update radius
    this._currentDonutRadius = this._currentDonutRadius + 25;

    document.getElementById('own-vehicle').classList.remove('active');
  }

  _toggleCarSelectionDropdown() {
    const toggleBoolean = !document.querySelector('.car-selection-dropdown').classList.contains('in');
    document.querySelector('.car-selection-dropdown')
      .classList.toggle('in', toggleBoolean);
    document.getElementById('example-vehicle').classList.toggle('in', toggleBoolean);
  }

  _addCarToComparison(event) {
    event.preventDefault();
    const listItem = event.target.parentNode.parentNode,
      co2Emissions = listItem.querySelector('.co2-emissions').innerText;

    analytics.pushUIInteractionAnalytics({
      element: 'input',
      type: 'click',
      elementName: `UI - Päästölaskuri - Valitse vertailtava auto - ${listItem.dataset.brandName} ${listItem.dataset.modelName}`
    });

    // Find example car donut from this._donutDetails
    const donutIndex = this._donutDetails.findIndex((donut) => {
      return donut.elements.svgElement.parentNode.dataset.sidepanelTargetId === 'example-vehicle';
    });

    const labelClass = this._donutDetails[donutIndex].elements.doughnutLabel.querySelector('span').className;
    this._donutDetails[donutIndex].elements.doughnutLabel.innerHTML = `${listItem.dataset.brandName} ${listItem.dataset.modelName} <span class="${labelClass}">${co2Emissions}</span> t`;

    this._donutDetails[donutIndex].carEmissions = listItem.dataset.co2Emissions;

    document.getElementById('example-vehicle').querySelector('p strong')
      .innerText = `${listItem.dataset.brandName} ${listItem.dataset.modelName}`;

    document.getElementById('example-vehicle').querySelector('.emission-details p strong .co2-emissions')
      .innerText = co2Emissions;

    document.getElementById('example-vehicle').querySelector('.example-car-co2-emissions')
      .innerText = listItem.dataset.co2Emissions;

    // Update circle
    const sliderElementValue = document.getElementById('mileage-slider').noUiSlider.get().replace(/\D/g, '');
    const emissionsPerYear = EmissionOffset.calculateEmissionsPerYear(listItem.dataset.co2Emissions, sliderElementValue * 1000);
    const donutDashoffset = this._calculateDonutDashoffset((emissionsPerYear / MAX_DONUT_VALUE) * 100, this._donutDetails[donutIndex].radius);
    this._changeDonutValue(this._donutDetails[donutIndex].elements.circleElement, donutDashoffset.strokeDashoffset);
  }

  _calculateSelectableCarsEmissions(sliderValue) {
    if(this.universalDonutContainer.length > 0) {
      const listItems = document.querySelectorAll('.car-selection-dropdown li');
      for(let i = 0; i < listItems.length; i++) {
        const emissionsPerYear = EmissionOffset.calculateEmissionsPerYear(listItems[i].dataset.co2Emissions, sliderValue * 1000);
        listItems[i].querySelector('.co2-emissions').innerText = emissionsPerYear.toFixed(2).replace('.', ',');
      }
    }
  }
}

export default EmissionComparison;
